import { Navigate } from "react-router-dom";
import { LOGIN_ROUTE } from "../routes/admin/adminRoutes";
import authManager from "../utils/admin/authManager";

const AdminAuth = ({ children }) => {
  if (authManager.hasAccessToken()) {
    return children;
  } else {
    return <Navigate to={LOGIN_ROUTE} replace />;
  }
};

export default AdminAuth;
